var React = require('react');

function ShutterBlade (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{stroke:#FFFFFF;}\n"),React.createElement("path",{"id":"shutter_blade","className":"st0","d":"M594.9,436.4c-1.9-1.2-3.8-2.5-5.5-3.9C459.5,318.8,312,234.4,152.8,169.3\n\tc-48.2-19.7-96.2-40-144.3-60c-2-0.9-4-1.8-8.5-3.9c15.2-5.5,28.2-10.4,41.4-15c137.4-47.3,278.3-78,423.2-90.3\n\tc8.5-0.7,13.7,1.4,18.7,8.5C568,128,606.3,260.7,598.2,406.8c-0.5,8.7-1.1,17.3-1.7,26C596.4,433.8,595.6,434.8,594.9,436.4z","key":1})]);
}

ShutterBlade.defaultProps = {"viewBox":"0 0 599.2 436.4","style":{"enableBackground":"new 0 0 599.2 436.4"}};

module.exports = ShutterBlade;

ShutterBlade.default = ShutterBlade;
